import {AbilityContext} from "@/context/AbilityContext";
import {AppEnum} from "@/models/enum/AppEnum";
import {Config} from "@/models/facade/Config";

export interface AppItem {
    code: string;
    url: string;
    /** Basename of the svg in src/assets/images/apps. */
    icon: string;
    /** Tint of the icon badge, mirroring the app chooser in the auth app. */
    variant: 'blue' | 'green' | 'purple';
    licenses?: string[];
    features?: string[];
}

export class AppsHelper {
    public static getApps(): AppItem[]
    {
        return Config.getInstance().read('apps') ?? [];
    }

    /**
     * The apps the current user is authorized for, the app they are in included.
     * The current app is always listed, so the drawer keeps its bearings when the
     * user is not (or not yet) authorized for anything.
     */
    public static getAuthorizedApps(currentApp: AppEnum): AppItem[]
    {
        return this.getApps().filter((app: AppItem) => {
            return this.isCurrentApp(app, currentApp) || this.isAuthorizedForApp(app);
        });
    }

    /**
     * The apps the current user is authorized for, except the app they are in.
     */
    public static getOtherAuthorizedApps(currentApp: AppEnum): AppItem[]
    {
        return this.getAuthorizedApps(currentApp).filter((app: AppItem) => {
            return !this.isCurrentApp(app, currentApp);
        });
    }

    public static isAuthorizedForApp(app: AppItem): boolean
    {
        const licenses = app.licenses ?? [];
        const features = app.features ?? [];

        if (licenses.length > 0 && !AbilityContext.isAuthorizedForAnyLicense(...licenses)) {
            return false;
        }

        return !(features.length > 0 && !AbilityContext.isAuthorizedForAnyFeature(...features));
    }

    public static isCurrentApp(app: AppItem, currentApp: AppEnum): boolean
    {
        return app.code === currentApp;
    }
}
